module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "layui-form-item"
  }, [_c('v-button', {
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', [_vm._v("添加新项 "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v("")])])]), _vm._v(" "), _c('v-button', {
    on: {
      "click": _vm.saveData
    }
  }, [_c('span', [_vm._v("保存数据 "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v("")])])])], 1), _vm._v(" "), _vm._l((_vm.dataList), function(item, index) {
    return _c('fieldset', {
      key: 't_' + index,
      staticClass: "layui-elem-field"
    }, [_c('legend', [_vm._v("\n      第" + _vm._s(_vm.dataList.length - index) + "项\n      "), _c('button', {
      staticClass: "layui-btn layui-btn-danger layui-btn-mini",
      on: {
        "click": function($event) {
          _vm.delItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "layui-icon"
    }, [_vm._v("")])])]), _vm._v(" "), _c('div', {
      staticClass: "layui-field-box"
    }, [_c('div', {
      staticClass: "layui-form-item"
    }, [_c('label', {
      staticClass: "layui-form-label"
    }, [_vm._v("名称")]), _vm._v(" "), _c('div', {
      staticClass: "layui-input-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "layui-input",
      attrs: {
        "placeholder": "网站或应用名称"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "layui-form-item"
    }, [_c('label', {
      staticClass: "layui-form-label"
    }, [_vm._v("密钥")]), _vm._v(" "), _c('div', {
      staticClass: "layui-input-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "layui-input",
      attrs: {
        "placeholder": "Base32 密钥"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }, function($event) {
          _vm.onKeyChange(item)
        }]
      }
    })])]), _vm._v(" "), (item.text) ? _c('div', {
      staticClass: "layui-form-item"
    }, [_c('label', {
      staticClass: "layui-form-label"
    }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
      staticClass: "layui-input-block"
    }, [_c('blockquote', {
      staticClass: "layui-elem-quote totp-code"
    }, [_c('span', {
      staticClass: "totp-digits"
    }, [_vm._v(_vm._s(item.code || '------'))]), _vm._v(" "), _c('span', {
      staticClass: "totp-timer"
    }, [_vm._v("（" + _vm._s(item.remaining) + "秒后刷新）")]), _vm._v(" "), _c('button', {
      staticClass: "layui-btn layui-btn-sm btn-copy",
      attrs: {
        "data-clipboard-text": item.code
      }
    }, [_vm._v("复制")])])])]) : _vm._e()])])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well"
  }, [_c('p', [_vm._v("可用于 Google Authenticator 等支持 TOTP 算法的二步验证。")]), _vm._v(" "), _c('p', [_vm._v("输入密钥后验证码会自动刷新。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49c0e59a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/twostepvalidation.vue
// module id = 590
// module chunks = 2